export default __webpack_public_path__ + "static/mandeln-c15260c9aaa6f464ef6dbf033c46f7ab.webp";